import { VideoPlayer } from './VideoPlayer';

// IDs extraits des liens fournis (respect strict casse et tirets bas)
const CASE_STUDIES = [
  { firstName: 'Sarah',    subtitle: '25 ans, Bruxelles',  videoId: 'OzlaS2NupYc' },
  { firstName: 'Chris',    subtitle: '23 ans, étudiant',   videoId: 'nItHtXor7I8' },
  { firstName: 'Guillaume', subtitle: '21 ans',            videoId: '_bjyegBz_EE' },
];

const CaseStudyCard = ({ study }) => (
  <div
    className="w-full mx-auto flex flex-col items-center gap-3"
    style={{ maxWidth: 280 }}
  >
    <VideoPlayer
      videoId={study.videoId}
      ratio="9:16"
      title={`Témoignage de ${study.firstName}`}
    />
    <div className="text-center">
      <p className="font-serif text-[#F5EFE3]" style={{ fontSize: 20, lineHeight: 1.15 }}>
        {study.firstName}
      </p>
      <p style={{ color: 'rgba(245, 239, 227, 0.45)', fontSize: 13, marginTop: 2 }}>
        {study.subtitle}
      </p>
    </div>
  </div>
);

// 4 captures Instagram — ratio d'origine, JAMAIS de recadrage
const SCREENSHOTS = [
  { id: 't1', src: '/assets/t1.jpg' },
  { id: 't2', src: '/assets/t2.jpg' },
  { id: 't3', src: '/assets/t3.jpg' },
  { id: 't4', src: '/assets/t4.jpg' },
];

const TestimonialScreenshots = () => (
  <div
    className="mx-auto w-full"
    style={{ maxWidth: 900 }}
    data-testid="testimonial-screenshots"
  >
    <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
      {SCREENSHOTS.map((s) => (
        <div
          key={s.id}
          className="card-forest"
          style={{ padding: 8, borderRadius: 12 }}
        >
          <img
            src={s.src}
            alt=""
            loading="lazy"
            style={{
              width: '100%',
              height: 'auto',
              display: 'block',
              objectFit: 'contain',
              borderRadius: 8,
            }}
          />
        </div>
      ))}
    </div>
  </div>
);

export const CaseStudies = () => {
  return (
    <section data-testid="case-studies" className="px-5 md:px-8 py-6 md:py-12 bg-hda-bg">
      <div className="max-w-3xl mx-auto flex flex-col gap-8">
        <div className="flex flex-col gap-3">
          <p className="microlabel">Ce qu&rsquo;ils pensent de la HDA</p>
          <h2 className="text-[26px] sm:text-3xl md:text-5xl leading-[1.1] max-w-2xl">
            Ils ont commencé sans aucune compétence.{' '}
            <span className="font-serif-italic font-normal italic">
              Voilà où ils en sont.
            </span>
          </h2>
        </div>

        {/* Vidéos : mobile 1 col centrée, desktop 3 cols */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-6">
          {CASE_STUDIES.map((s) => (
            <CaseStudyCard key={s.firstName} study={s} />
          ))}
        </div>

        {/* Captures Instagram — ratio naturel, contain */}
        <TestimonialScreenshots />
      </div>
    </section>
  );
};

export default CaseStudies;
